<template>
  <div class="pay-money">
    <div class="pay-money__unit">{{ price.prefix }}</div>
    <div class="pay-money__number">{{ price.value }}</div>
  </div>
</template>

<script setup lang="ts" name="PayMoney">
import { formatPrice } from '~/utils/equity-helper';
const props = defineProps<{ text: number }>();

const price = computed(() => formatPrice(props.text));
</script>

<style lang="scss">
.pay-money {
  display: flex;
  color: #ff2c2c;
  font-size: 28px;
  font-weight: 600;
  line-height: 1;
}
</style>
